import React, { useState } from 'react';
import { Shield, Zap, Target, Trophy, ArrowRight, CheckCircle2, Star, Clock, Gift } from 'lucide-react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Countdown } from './components/Countdown';
import { AccordionItem } from './components/Accordion';
import { modulesData, bonusesData } from './data/content';
const CHECKOUT_URL = 'https://checkout.ebookpoint.shop/cart/59546532184145:1';
export function App() {
  const [openModule, setOpenModule] = useState<number | null>(0);
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const handleBuyClick = () => {
    window.location.href = CHECKOUT_URL;
  };
  const scrollToBuy = () => {
    const el = document.getElementById('compra');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className="min-h-screen bg-[#1F6B1F] font-sans text-white selection:bg-white selection:text-green-800" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* HERO SECTION */}
      <section className="relative bg-[#14532D] text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-3">
        {/* Pitch background effect */}
        <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(255,255,255,0.08) 40px, rgba(255,255,255,0.08) 80px)',
        backgroundSize: '100% 80px'
      }} data-id="element-4"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1F6B1F]" data-id="element-5"></div>

        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/30 text-white text-sm font-bold mb-6" data-id="element-7">
            <Zap className="w-4 h-4" data-id="element-8" />
            <span data-id="element-9">
              SISTEMA DE ENTRENAMIENTO PARA FUTBOLISTAS DE TODOS LOS NIVELES
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl font-black mb-10 leading-tight tracking-tight" data-id="element-10">
            Tu cabeza ve la jugada,{' '}
            <span className="text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.4)] underline decoration-white/40 decoration-4 underline-offset-8" data-id="element-11">
              pero tu cuerpo llega tarde
            </span>
          </h1>

          <div className="relative max-w-[81%] sm:max-w-[60.5%] mx-auto mb-10 cursor-pointer group" onClick={scrollToBuy} data-id="element-12">
            <div className="absolute -inset-4 bg-white/10 blur-3xl rounded-full" data-id="element-13"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vqe3zUESv1UfXVxay7mGt9/ChatGPT_Image_May_20,_2026,_05_40_24_PM.png" alt="Futbol Explosivo Pro" className="relative rounded-2xl shadow-2xl object-contain w-full group-hover:scale-[1.02] transition-transform duration-300" data-id="element-14" />
          </div>

          <p className="text-lg md:text-xl text-green-50 mb-10 max-w-2xl mx-auto font-medium" data-id="element-15">
            El programa definitivo para jugadores que quieren ser más
            explosivos, ganar cada duelo y patear más fuerte, sin lesionarse en
            el intento.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-10 text-sm font-medium" data-id="element-16">
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-17">
              <Shield className="w-4 h-4 text-white" data-id="element-18" />
              <span data-id="element-19">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-20">
              <Zap className="w-4 h-4 text-white" data-id="element-21" />
              <span data-id="element-22">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2 bg-white/15 px-4 py-2 rounded-full border border-white/20" data-id="element-23">
              <Trophy className="w-4 h-4 text-white" data-id="element-24" />
              <span data-id="element-25">Nivel Amateur a Pro</span>
            </div>
          </div>

          <button onClick={scrollToBuy} className="group relative inline-flex items-center justify-center gap-3 bg-white text-[#1F6B1F] text-xl md:text-2xl font-black py-5 px-10 rounded-2xl shadow-[0_10px_40px_-10px_rgba(255,255,255,0.5)] hover:shadow-[0_10px_50px_-10px_rgba(255,255,255,0.8)] hover:scale-105 transition-all duration-300 w-full md:w-auto" data-id="element-26">
            <span className="absolute -top-3 -right-3 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full animate-bounce shadow-lg" data-id="element-27">
              ¡OFERTA HOY!
            </span>
            <span data-id="element-28">DEJA DE LLEGAR TARDE A LA PELOTA</span>
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-29" />
          </button>
        </div>
      </section>

      {/* PROBLEM / SOLUTION SECTION */}
      <section className="py-20 px-4 bg-[#1F6B1F]" data-id="element-30">
        <div className="max-w-4xl mx-auto" data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-33">
              ¿Te pasa esto en la cancha?
            </h2>
            <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-34">
              <div className="bg-white p-6 rounded-2xl border-4 border-red-200 shadow-xl" data-id="element-35">
                <h3 className="font-bold text-red-600 mb-4 text-lg uppercase" data-id="element-36">
                  Lo que te frena hoy
                </h3>
                <ul className="space-y-4" data-id="element-37">
                  <li className="flex items-start gap-3" data-id="element-38">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-39" />
                    <span className="text-gray-700 font-medium" data-id="element-40">
                      Llegás tarde a las pelotas divididas y perdés los
                      anticipos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-41">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-42" />
                    <span className="text-gray-700 font-medium" data-id="element-43">
                      Le pegás a la pelota y sale sin fuerza, o forzás tanto que
                      perdés precisión.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-44">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-45" />
                    <span className="text-gray-700 font-medium" data-id="element-46">
                      Vas al gimnasio pero te sentís "pesado" o lento en la
                      cancha.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-47">
                    <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-48" />
                    <span className="text-gray-700 font-medium" data-id="element-49">
                      Te fundís rápido o te lesionás seguido (isquios,
                      aductores).
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-2xl border-4 border-[#1F6B1F]/30 shadow-xl" data-id="element-50">
                <h3 className="font-bold text-[#1F6B1F] mb-4 text-lg uppercase" data-id="element-51">
                  Con Fútbol Explosivo Pro
                </h3>
                <ul className="space-y-4" data-id="element-52">
                  <li className="flex items-start gap-3" data-id="element-53">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-54" />
                    <span className="text-gray-800 font-medium" data-id="element-55">
                      Ganar explosión en los primeros 5 metros (donde se define
                      el fútbol).
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-56">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-57" />
                    <span className="text-gray-800 font-medium" data-id="element-58">
                      Aumentar drásticamente tu potencia de remate con técnica
                      correcta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-59">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-60" />
                    <span className="text-gray-800 font-medium" data-id="element-61">
                      Desarrollar "fuerza útil" que se transfiere directamente
                      al partido.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-62">
                    <CheckCircle2 className="w-6 h-6 text-[#1F6B1F] flex-shrink-0 mt-0.5" data-id="element-63" />
                    <span className="text-gray-800 font-medium" data-id="element-64">
                      Prevenir lesiones comunes con rutinas específicas para
                      futbolistas.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODULES SECTION */}
      <section className="py-20 px-4 bg-[#14532D] border-t border-white/10" data-id="element-65">
        <div className="max-w-3xl mx-auto" data-id="element-66">
          <div className="text-center mb-12" data-id="element-67">
            <span className="text-white/80 font-bold tracking-wider uppercase text-sm" data-id="element-68">
              El Programa Principal
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white mt-2 mb-4" data-id="element-69">
              ¿Qué incluye el programa?
            </h2>
            <p className="text-green-100 text-lg" data-id="element-70">
              5 tomos estructurados paso a paso para transformar tu físico.
            </p>
          </div>

          <div className="space-y-2" data-id="element-71">
            {modulesData.map((module, index) => <AccordionItem key={index} title={module.title} subtitle={module.subtitle} content={module.content} isOpen={openModule === index} onClick={() => setOpenModule(openModule === index ? null : index)} data-id="element-72" />)}
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-[#1F6B1F] text-white relative overflow-hidden" data-id="element-73">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-74">
          <div className="absolute w-[800px] h-[800px] rounded-full border-[40px] border-white -top-[400px] -right-[200px]" data-id="element-75"></div>
          <div className="absolute w-[600px] h-[600px] rounded-full border-[20px] border-white -bottom-[300px] -left-[100px]" data-id="element-76"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-77">
          <div className="text-center mb-12" data-id="element-78">
            <div className="inline-block bg-white text-[#1F6B1F] font-black px-4 py-1 rounded-full text-sm mb-4 transform -rotate-2 shadow-lg" data-id="element-79">
              GRATIS SOLO POR HOY
            </div>
            <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-80">
              Bonos Exclusivos
            </h2>
            <p className="text-green-100 text-lg" data-id="element-81">
              Llevate estos 5 complementos valorados en más de $30.000,
              totalmente gratis con tu compra hoy.
            </p>
          </div>

          <div className="space-y-2" data-id="element-82">
            {bonusesData.map((bonus, index) => <AccordionItem key={index} title={bonus.title} subtitle={bonus.subtitle} content={bonus.content} isOpen={openBonus === index} onClick={() => setOpenBonus(openBonus === index ? null : index)} isBonus={true} data-id="element-83" />)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="py-20 px-4 bg-[#14532D]" data-id="element-84">
        <div className="max-w-5xl mx-auto" data-id="element-85">
          <div className="text-center mb-12" data-id="element-86">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-87">
              Jugadores que ya son más explosivos
            </h2>
            <div className="flex justify-center gap-1 text-amber-300" data-id="element-88">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-89" />)}
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-90">
            <TestimonialCard name="Martín F." age="24 años" role="Delantero" text="Siempre fui rápido pero me pasaba de largo o me ganaban con el cuerpo. Con el Tomo 3 de fuerza útil y los ejercicios de frenada, ahora gano los duelos y defino con mucho más equilibrio. Un antes y un después para el fútbol 11." data-id="element-91" />
            <TestimonialCard name="Lucas G." age="28 años" role="Volante" text="Juego fútbol 7 con amigos y me fundía a los 20 minutos. Empecé a aplicar las rutinas express porque no tengo tiempo de ir al gym. Mejoré mi arranque y la potencia de mi pegada de afuera del área es otra cosa." data-id="element-92" />
            <TestimonialCard name="Diego S." age="31 años" role="Defensor" text="Venía de dos desgarros seguidos en los isquios. El bono anti-lesiones vale oro. Hace 4 meses que no me pierdo un partido y me siento mucho más seguro en los giros y cierres rápidos." data-id="element-93" />
            <TestimonialCard name="Tomás R." age="22 años" role="Extremo" text="Pensé que pateaba fuerte hasta que vi el módulo de técnica de remate. Corregí el pie de apoyo y la rotación de cadera y ahora la pelota sale como un misil. Mis compañeros me preguntan qué estoy tomando jaja." data-id="element-94" />
            <TestimonialCard name="Alejandro M." age="35 años" role="Lateral" text="A mi edad pensé que ya no podía ser más rápido. El plan de 12 semanas me ordenó. Dejé de hacer rutinas de culturista y me enfoqué en potencia. Me siento más ágil que a los 25." data-id="element-95" />
          </div>
        </div>
      </section>

      {/* PRICING & CTA SECTION */}
      <section id="compra" className="py-20 px-4 bg-[#1F6B1F] border-t border-white/10 scroll-mt-4" data-id="element-96">
        <div className="max-w-3xl mx-auto text-center" data-id="element-97">
          <Countdown data-id="element-98" />

          <div className="bg-white border-4 border-[#1F6B1F] rounded-3xl p-8 md:p-12 shadow-2xl relative mt-8" data-id="element-99">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1F6B1F] text-white font-black px-6 py-2 rounded-full shadow-lg border-4 border-white" data-id="element-100">
              OFERTA ESPECIAL
            </div>

            <h2 className="text-3xl font-black text-gray-900 mb-2 mt-4" data-id="element-101">
              Futbol Explosivo Pro
            </h2>
            <p className="text-gray-600 mb-8 font-medium" data-id="element-102">
              Programa Completo + 5 Bonos Exclusivos
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-103">
              <span className="text-gray-400 text-2xl font-bold line-through mb-2" data-id="element-104">
                $52.690
              </span>
              <div className="flex items-start" data-id="element-105">
                <span className="text-[#1F6B1F] font-bold text-3xl mt-2" data-id="element-106">
                  $
                </span>
                <span className="text-[#1F6B1F] font-black text-7xl tracking-tighter" data-id="element-107">
                  19.990
                </span>
                <span className="text-[#1F6B1F] font-bold text-xl mt-2" data-id="element-108">
                  ARS
                </span>
              </div>
              <p className="text-sm text-[#1F6B1F] font-bold bg-[#1F6B1F]/10 px-3 py-1 rounded-full mt-4" data-id="element-109">
                Ahorrás $32.700 hoy
              </p>
            </div>

            <button onClick={handleBuyClick} className="group relative inline-flex items-center justify-center gap-3 bg-[#1F6B1F] hover:bg-[#14532D] text-white text-xl md:text-2xl font-black py-6 px-8 rounded-2xl shadow-[0_10px_40px_-10px_rgba(31,107,31,0.6)] hover:shadow-[0_10px_50px_-10px_rgba(31,107,31,0.9)] hover:scale-105 transition-all duration-300 w-full mb-6" data-id="element-110">
              <span data-id="element-111">SÍ, QUIERO EL PROGRAMA AHORA</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-112" />
            </button>

            <div className="flex flex-col items-center gap-4 text-sm text-gray-500 font-medium" data-id="element-113">
              <div className="flex items-center gap-6" data-id="element-114">
                <div className="flex items-center gap-2" data-id="element-115">
                  <Shield className="w-5 h-5 text-[#1F6B1F]" data-id="element-116" />
                  <span data-id="element-117">Pago 100% Seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-118">
                  <Clock className="w-5 h-5 text-[#1F6B1F]" data-id="element-119" />
                  <span data-id="element-120">Acceso de por vida</span>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-2" data-id="element-121">
                <img src="https://logospng.org/download/mercado-pago/logo-mercado-pago-icono-1024.png" alt="Mercado Pago" className="h-6 object-contain grayscale opacity-60" data-id="element-122" />
                <span data-id="element-123">Aceptamos Mercado Pago y Tarjetas</span>
              </div>
            </div>
          </div>

          {/* EXTRA GIFT BANNER */}
          <div onClick={handleBuyClick} className="mt-8 cursor-pointer group bg-white border-4 border-[#1F6B1F] rounded-2xl p-6 shadow-2xl hover:scale-[1.02] transition-transform duration-300" role="button" tabIndex={0} data-id="element-124">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left" data-id="element-125">
              <div className="bg-[#1F6B1F] p-3 rounded-full shadow-lg flex-shrink-0" data-id="element-126">
                <Gift className="w-8 h-8 text-white" data-id="element-127" />
              </div>
              <div data-id="element-128">
                <p className="text-xs font-black text-[#1F6B1F] uppercase tracking-wider mb-1" data-id="element-129">
                  🎁 Regalo extra
                </p>
                <p className="text-lg md:text-xl font-black text-gray-900 leading-tight" data-id="element-130">
                  Comprando HOY llevate una calculadora de proteínas e
                  hidratación
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#0a2f10] text-green-100/70 py-8 text-center text-sm" data-id="element-131">
        <p data-id="element-132">© 2026 Futbol Explosivo Pro. Todos los derechos reservados.</p>
        <p className="mt-2 text-xs opacity-60" data-id="element-133">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}
function XIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-134">
      <path d="M18 6 6 18" data-id="element-135" />
      <path d="m6 6 12 12" data-id="element-136" />
    </svg>;
}
function TestimonialCard({
  name,
  age,
  role,
  text
}: {
  name: string;
  age: string;
  role: string;
  text: string;
}) {
  return <div className="bg-white p-6 rounded-2xl shadow-xl border border-green-100 flex flex-col h-full" data-id="element-137">
      <div className="flex text-amber-400 mb-4" data-id="element-138">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-139" />)}
      </div>
      <p className="text-gray-700 mb-6 flex-grow italic" data-id="element-140">"{text}"</p>
      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-50" data-id="element-141">
        <div className="w-10 h-10 bg-[#1F6B1F] rounded-full flex items-center justify-center text-white font-bold" data-id="element-142">
          {name.charAt(0)}
        </div>
        <div data-id="element-143">
          <p className="font-bold text-gray-900 text-sm" data-id="element-144">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-145">
            {age} • {role}
          </p>
        </div>
      </div>
    </div>;
}